// TOREFACTO : Check with design if we keep this overlay logic to delete an HD File or not
import { KdsButton, KdsText } from "@kazaar-platform/design-system";
import { T, useTranslate } from "@tolgee/react";

import { type RemoveHdFileOverlayProps } from "./RemoveHdFileOverlay.types";

export const RemoveHDFileOverlay = ({
  onCancel,
  onDelete,
  isLoading,
}: RemoveHdFileOverlayProps) => {
  const { t } = useTranslate();

  return (
    <div className="absolute left-0 top-0 flex h-full w-full animate-slide-in items-center rounded-br-sm border border-slate-200 bg-slate-50 p-4">
      <div className="w-full">
        <KdsText>
          <T
            keyName="order.myOrdersItemDetails.confirmHdFileDeletion"
            params={{ b: <strong /> }}
          />
        </KdsText>
      </div>

      <div className="flex w-full items-start justify-end gap-4">
        <KdsButton
          size="small"
          variant="outlined"
          color="neutral"
          onPress={onCancel}
          isLoading={isLoading}
        >
          {t("buttons.cancel")}
        </KdsButton>

        <KdsButton
          size="small"
          color="error"
          onPress={onDelete}
          isLoading={isLoading}
        >
          {t("buttons.deleteHdFile")}
        </KdsButton>
      </div>
    </div>
  );
};
